import PasswordTextField from "../general/inputs/PasswordTextField";
import React from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@mui/styles";
import {Button, Container, Grid, TextField} from "@mui/material";
import {makeRequest} from "../../services/requestService";
import {API_URL} from "../../constants";
import {useSnackbar} from "notistack";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

EditProfile.propTypes = {
    usernameInit: PropTypes.string,
    pseudoInit: PropTypes.string,
    emailInit: PropTypes.string,
    onSuccess: PropTypes.func,
    onError: PropTypes.func
}

EditProfile.defaultProps = {
    usernameInit: "",
    pseudoInit: "",
    emailInit: "",
    onSuccess: () => null,
    onError: () => null
}


export default function EditProfile(props) {
    const classes = useStyles();
    const {usernameInit, pseudoInit, emailInit, onSuccess, onError} = props;
    const {t} = useTranslation('common');
    const {enqueueSnackbar} = useSnackbar();
    const [username, setUsername] = React.useState(usernameInit);
    const [pseudo, setPseudo] = React.useState(pseudoInit);
    const [email, setEmail] = React.useState(emailInit);
    const [password, setPassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");
    const [newPasswordConf, setNewPasswordConf] = React.useState("");

    const onChangePseudo = (e) => {
        setPseudo(e.target.value);
    };

    const onChangeUsername = (e) => {
        setUsername(e.target.value);
    };

    const onChangeEmail = (e) => {
        setEmail(e.target.value);
    };

    const onChangePassword = (e) => {
        setPassword(e.target.value);
    };

    const onChangeNewPassword = (e) => {
        setNewPassword(e.target.value);
    };

    const onChangeNewPasswordConf = (e) => {
        setNewPasswordConf(e.target.value);
    };

    const handleEdit = () => {
        if (newPassword === newPasswordConf) {
            makeRequest(`${API_URL}/user/update`, 'PUT', {pseudo, username, email, password, newPassword})
                .then((response) => {
                    if (response.status === 200) {
                        enqueueSnackbar(response.data.message, {variant: "success"});
                        onSuccess();
                    } else {
                        onError();
                    }
                });
        } else {
            if (newPassword.length > 0 || newPasswordConf.length > 0) {
                // ERROR
                enqueueSnackbar("Le nouveau mot passe ne correspond pas à la confirmation", {variant: "error"});
            }
        }
    }

    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label={t('main.components.form.placeholder.username')}
                                name="username"
                                value={username}
                                onChange={onChangeUsername}
                                autoFocus
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="pseudo"
                                label={t('main.components.form.placeholder.pseudo')}
                                name="pseudo"
                                value={pseudo}
                                onChange={onChangePseudo}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                color="secondary"
                                variant="outlined"
                                fullWidth
                                id="email"
                                label={t('main.components.form.placeholder.email')}
                                type="email"
                                name="email"
                                value={email}
                                autoComplete="email"
                                onChange={onChangeEmail}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordTextField
                                value={password}
                                label={t('main.components.form.placeholder.password')}
                                onChange={onChangePassword}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordTextField
                                value={newPassword}
                                label={t('main.components.form.placeholder.newPassword')}
                                onChange={onChangeNewPassword}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PasswordTextField
                                value={newPasswordConf}
                                label={t('main.components.form.placeholder.confirmPassword')}
                                onChange={onChangeNewPasswordConf}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={handleEdit}
                                className={classes.submit}
                            >
                                {t('main.components.saveDialog.save')}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Container>
    );
}